import React from "react";
import LinearLoader from "./../LinearLoader/LinearLoader";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { getUnitsData } from "./../../modules/units";
import { getPermissions } from "./../../modules/permissions";
import { getUserInfo } from "../../modules/user";
import { getDashboardConfiguration } from "../../modules/dashboard";
import { getScanRanges } from "../../modules/scan";
import hasTP from "./../../utilities/unitsFilters";
import { push } from "react-router-redux";

import { DOMAIN } from "../../utilities/consts";

class DataLoader extends React.Component {
  componentDidMount = () => {
    this.props.getUserInfo().catch(err => {
      console.log(err);
      window.open(`${DOMAIN}/mapa.aspx`, "_SELF");
    });
    this.props
      .getPermissions()
      .then(() => {
        this.props
          .getUnitsData()
          .then(() => {
            this.props.getDashboardConfiguration().then(() => {
              console.log("sadas");
              this.props.changePage("./dashboard");
            });
            this.props.getScanRanges({
              unidades: this.props.units
                .filter(v => hasTP(v, [".can"]))
                .map(v => v.Unidad)
            });
          })
          .catch(err => {
            console.log(err);
            window.open(`${DOMAIN}/mapa.aspx`, "_SELF");
          });
      })
      .catch(err => {
        console.log(err);
        window.open(`${DOMAIN}/mapa.aspx`, "_SELF");
      });
  };

  render() {
    const { isLoadingUnits, isLoadingPermissions } = this.props;
    const isLoading = isLoadingUnits && isLoadingPermissions;
    return (
      <React.Fragment>
        {isLoading && <LinearLoader />}
        {!isLoading && null}
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getUnitsData,
      getUserInfo,
      getPermissions,
      getDashboardConfiguration,
      getScanRanges,
      changePage: page => push(page)
    },
    dispatch
  );

const mapStateToProps = state => ({
  isLoadingUnits: state.units.isLoading,
  isLoadingPermissions: state.permissions.isLoading,
  units: state.units.data
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DataLoader);



// WEBPACK FOOTER //
// ./src/components/DataLoader/DataLoader.js